import { trackEvents } from "./trackEvents";
import { TRACKING_EVENT_NAME } from "./tracking.service";

export function sendHeartbeat(payload: any) {
  trackEvents(
    TRACKING_EVENT_NAME.HEARTBEAT,
    TRACKING_EVENT_NAME.HEARTBEAT,
    payload,
  );
}
